export default __webpack_public_path__ + "static/media/img_2.8bd26ba9.jpg";